export default __webpack_public_path__ + "skpu.png?afadde8fc0e4379b8efdbdc33031e005";